import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { ApiOrganizationDescriptor } from './model/api.organization';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { OrganizationModel } from './model/organization.model';
import { IDataService } from '../common/IDataService';

@Injectable()
export class OrganizationService extends RESTServiceBase implements IDataService<OrganizationModel> {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'OrganizationManagement',
      authService,
      config.OMSConfig
    );

  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
  
  public async create(organization: OrganizationModel): Promise<OrganizationModel> {
    return new OrganizationModel(await super.post<ApiOrganizationDescriptor>(organization));
  }

  public async getOrganizations(view?: View): Promise<List<OrganizationModel>> {
    const orgs = await super.get<List<ApiOrganizationDescriptor>>(undefined, view);
    orgs.value = orgs.value.map(o => new OrganizationModel(o));
    return orgs as List<OrganizationModel>;
  }

  public async list(view?: View): Promise<List<OrganizationModel>> {
    const orgs = await super.post<List<ApiOrganizationDescriptor>>(view, undefined, "list");
    orgs.value = orgs.value.map(o => new OrganizationModel(o));
    return orgs as List<OrganizationModel>;
  }

  async GetList(v: View): Promise<List<OrganizationModel>> {
    return await this.list(v);
  }
  async GetById(id: string): Promise<OrganizationModel> {
    return await this.getById(id);
  }
  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public async update(id: string, organization: OrganizationModel): Promise<OrganizationModel> {
    return new OrganizationModel(await super.put<ApiOrganizationDescriptor>(id, organization));
  }

  public async getById(id: string): Promise<OrganizationModel> {
    return new OrganizationModel(await super.get<ApiOrganizationDescriptor>(id));
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/organization/organization.service.ts